import Strings from "@my-dld/assets/strings";
import React from "react";

export const SpinnerLoader: React.FunctionComponent<{ extraClass?: string }> = props => {
	return <div className={ "spinner-border " + ( props.extraClass ? props.extraClass : "" ) } role="status">
		<span className="sr-only">{ Strings.loading }</span>
	</div>;
};
